document.addEventListener("DOMContentLoaded", function () {
  let triggers = document.querySelectorAll(".collection-trigger");

  if (triggers.length == 0) return;

  triggers[0].classList.add("active");
  let defaultCollectionTitle = triggers[0].getAttribute(
    "data-collection-title"
  );
  let defaultTarget = document.querySelector(
    '[data-collection-title="' + defaultCollectionTitle + '"]'
  );
  defaultTarget.classList.add("z-1");

  triggers.forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      triggers.forEach(function (t) {
        t.classList.remove("active");
        t.setAttribute("aria-selected", "false");
      });

      trigger.classList.add("active");
      trigger.setAttribute("aria-selected", "true");

      let collectionTitle = trigger.getAttribute("data-collection-title");

      let target = document.querySelector(
        '.target-collection-image[data-collection-title="' +
          collectionTitle +
          '"]'
      );

      let allTargets = document.querySelectorAll(".target-collection-image");
      allTargets.forEach(function (t) {
        t.classList.remove("z-1");
      });

      target.classList.add("z-1");
    });
  });
});
